








































































import { defineComponent, onUnmounted, ref } from '@nuxtjs/composition-api'
import { computed } from '@vue/composition-api'
import { masks } from '@/validation'
import { FormInputType } from '@/contracts/FormInputType'
import { FormMask } from '@/contracts/FormMask'
import InputError from '@/components/Inputs/new-design/InputError.vue'
import { applyPhoneMask } from '@/composition/phoneMask'

export default defineComponent({
  name: 'InputText',
  components: { InputError },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    id: { type: String, default: '' },
    type: { type: String, default: FormInputType.Text },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    value: { type: String, default: '' },
    maxLength: { type: Number, default: 1200 },
    disabled: { type: Boolean, default: false },
    disabledState: { type: Boolean, default: false },
    disabledStyle: { type: Boolean, default: false },
    mask: { type: [String, RegExp, Array], default: FormMask.NotSet },
    error: { type: [String, Boolean], default: '' },
    withUpperCase: { type: Boolean, default: false },
    withCapitalise: { type: Boolean, default: false },
    useCustomPhoneMask: { type: Boolean, default: true },
    disableAutofill: { type: Boolean, default: false },
    testId: { type: String, default: '' },
  },
  setup(props, { emit }) {
    const isFocused = ref(false)
    const input = ref<HTMLInputElement | null>(null)

    const inputMask = computed(() =>
      props.mask in masks ? masks[props.mask] : props.mask
    )

    const isCustomPhoneMask = computed(() => {
      const isPhoneMask =
        inputMask.value === '+7 (###) ###-####' ||
        inputMask.value === '+7 (###) ###-##-##'
      return props.useCustomPhoneMask && isPhoneMask
    })

    const modifyInput = (value: string): string => {
      let result = value

      if (props.withUpperCase) {
        result = result.toUpperCase()
      }

      if (props.withCapitalise && /(^[а-яё]$)|(\s[а-яё]$)/.test(result)) {
        result = result.slice(0, -1) + result[result.length - 1].toUpperCase()
      }

      return result
    }

    const onInput = (event: Event) => {
      const el = event.target as HTMLInputElement
      let value = el.value

      if (value.length > props.maxLength) {
        el.value = props.value
        return
      }

      if (isCustomPhoneMask.value) {
        value = applyPhoneMask(value, props.value, inputMask.value)
        el.value = value
      }

      emit('input', modifyInput(value))
    }

    const onFocus = () => {
      if (props.disabledState) return

      isFocused.value = true
      emit('focus')
    }

    const onBlur = () => {
      isFocused.value = false
      emit('blur')
    }

    const onFocusClick = () => {
      if (props.disabledState) return

      isFocused.value = true
      input.value?.focus()
    }

    const onPrependClick = (e: MouseEvent) => {
      e.stopPropagation()
    }

    const onEnter = () => {
      emit('enter') // Передаем событие в родительский компонент
    }

    onUnmounted(() => {
      emit('unmounted')
    })

    return {
      onFocusClick,
      input,
      isFocused,
      inputMask,
      onInput,
      onFocus,
      onBlur,
      onPrependClick,
      onEnter,
      isCustomPhoneMask,
    }
  },
})
